import { Component } from "vue-property-decorator";
import baseUserContextEmptyPage from '../baseUserContextEmptyPage';

@Component({
})
export default class error403Page extends baseUserContextEmptyPage {
}